import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";
import { typeLabel } from "@/utils/format";

interface VideoCardProps {
  video: Video;
  className?: string;
}

export default function VideoCard({ video, className = "" }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className={`group block rounded-lg overflow-hidden bg-background-50 border border-background-200 transition-all duration-300 hover:border-primary-300 cursor-pointer ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 视频封面`}
          title={`${video.title} - 在线视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {/* Rating badge */}
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-semibold">
          {video.rating.toFixed(1)}
        </span>

        {/* Type badge */}
        <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium backdrop-blur-sm">
          {typeLabel(video.type)}
        </span>

        {/* Duration */}
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium backdrop-blur-sm">
          {video.duration}
        </span>

        {/* Hover play */}
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-play-fill text-2xl pl-0.5"></i>
          </span>
        </span>
      </div>

      <div className="p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          {video.subtitle}
        </p>
        <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
          <span>{video.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="line-clamp-1">{video.region}</span>
          <span className="ml-auto flex items-center gap-1 text-foreground-400">
            <i className="ri-fire-line"></i>
            {video.playCount >= 10000
              ? `${(video.playCount / 10000).toFixed(0)}万`
              : video.playCount}
          </span>
        </div>
      </div>
    </Link>
  );
}